window.g2 = require('./src/index.ts').default;

// gatsby-browser.js
exports.shouldUpdateScroll = ({ routerProps, prevRouterProps }) => {
  if (routerProps.location.hash) {
    return false;
  }
  return true;
};
